import React from 'react';

import PropTypes from 'prop-types';
import { connectHits } from 'react-instantsearch-dom';

import Hit from '../hit/Hit';

/**
 * The list of results from Algolia.
 */
const Hits = ({ hits, locale, resultsPageData, urlSearchParams }) => {
  const filterAltText = (variant) => {
    return variant?.image?.alt; 
  };

  const getFilteredHits = (algoliaSearchResults) => {
    algoliaSearchResults.forEach((hit)=> {
      hit.otherVariants = hit.otherVariants.filter(filterAltText);
    });
    return algoliaSearchResults;
  };

  const filteredHits = getFilteredHits(hits);
  return (
    <div>
      {filteredHits.map((hit) =>
        <Hit
          key={hit.id}
          locale={locale}
          resultsPageData={resultsPageData}
          urlSearchParams={urlSearchParams}
          { ...hit }
        />,
      )}
    </div>
  );
};

Hits.propTypes = {
  /**
   * The response of results from Algolia.
   */
  hits: PropTypes.arrayOf(PropTypes.shape({
    _highlightResult: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    _rankingInfo: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    hookContent: PropTypes.string,
    locale: PropTypes.string,
    name: PropTypes.string,
    otherVariants: PropTypes.arrayOf(PropTypes.shape({
      color: PropTypes.string,
      image: PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string,
      }),
      url: PropTypes.string,
    })),
    price: PropTypes.number,
    urlSearchParams: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  })).isRequired,
  /**
   * locale string
   */
  locale: PropTypes.string.isRequired,
  /**
   * The search param queries object.
   */
  urlSearchParams: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types

  /**
   * The contentful icons and title for the Made For section.
   */
   resultsPageData: PropTypes.shape({
    accordionRowsCollection: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({
        cushionTitle: PropTypes.string,
        heelDropTitle: PropTypes.string,
        linkText: PropTypes.string,
        supportTitle: PropTypes.string,
        surfaceTitle: PropTypes.string,
        title: PropTypes.string,
        weightTitle: PropTypes.string,
      })),
    }),
    carouselLeftArrow: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    carouselRightArrow: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    closeMatchText: PropTypes.string,
    colorsText: PropTypes.string,
    colorText: PropTypes.string,
    editAnswersText: PropTypes.string,
    madeFor: PropTypes.shape({
      iconsCollection: PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.shape({
          facet: PropTypes.string,
          icon: PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string,
          }),
          title: PropTypes.string,
          value: PropTypes.string,
        })),
      }),
      title: PropTypes.string,
    }),
    noResultsErrorText: PropTypes.string,
    perfectMatchText: PropTypes.string,
    productCtaText: PropTypes.string,
    productCtaTextLocation: PropTypes.bool,
    restartQuizText: PropTypes.string,
  }),
};

Hits.defaultProps = {
  resultsPageData: {},
};

export default connectHits(Hits);
